var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2319 10.6401C5.5859 11.0641 6.2159 11.1221 6.6399 10.7681L10.9999 7.1351V19.0001C10.9999 19.5521 11.4479 20.0001 11.9999 20.0001C12.5519 20.0001 12.9999 19.5521 12.9999 19.0001V7.1351L17.3599 10.7681C17.7849 11.1221 18.4149 11.0641 18.7679 10.6401C19.1219 10.2161 19.0649 9.5851 18.6399 9.2321L12.6399 4.2321C12.5929 4.1921 12.5369 4.1731 12.4849 4.1431C12.4439 4.1191 12.4079 4.0911 12.3629 4.0731C12.2459 4.0271 12.1239 4.0001 11.9999 4.0001C11.8759 4.0001 11.7539 4.0271 11.6369 4.0731C11.5919 4.0911 11.5559 4.1191 11.5149 4.1431C11.4629 4.1731 11.4069 4.1921 11.3599 4.2321L5.3599 9.2321C4.9359 9.5851 4.8779 10.2161 5.2319 10.6401Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.951b98108b9e25dc53310f393b03275b.svg";
export { ForwardRef as ReactComponent };